
const attendance = {
  strict: true,
  namespaced: true,
  state: {
    detailsData:{},
    cancelable:'',
    // 发起请假页面缓存数据
    creatFlow:{},

    type:'',
    val:'',
    leaveTeachers: {},
    addCCIndex: '',

    barData:[],
    firstLoad:false

  },
  mutations: {
    getDetailsData (state, childList) {
      state.detailsData = childList
    },
    getCancelable(state, i){
      state.cancelable = i
    },
    getCreatFlow(state, childList){
      state.creatFlow = childList
    },
    settype (state, type) { // 类型
      state.type = type;
    },
    setVal (state, val) { // 行内容
      state.val = val;
    },
    addLeaveTeachers(state, val) {
      console.log(val)
      Object.assign(state.leaveTeachers, {[val.index]: val.list})
    },
    setLeaveTeachersNull(state) {
      state.leaveTeachers = {}
    },
    setAddCCIndex(state,val) {
      state.addCCIndex = val;
    },
    setBarData(state, childList){
      state.barData = childList
    },
    setFirstLoad(state,val){
      state.firstLoad = val
    }
  },
}
export default attendance
